/**
 * Visit Late Canceled Trigger Component
 *
 * Trigger: "late canceled a visit"
 * Shows: service select
 */

import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { fetchServicesOptions } from 'src/models/service/service';
import { FormSelect } from 'src/shared/Forms/Fields/FormSelect';

import { TriggerComponentProps } from '../automationTriggers';

export const VisitLateCanceledTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { data: services = [] } = useQuery({
    queryKey: ['services', 'options'],
    queryFn: () => fetchServicesOptions(),
    staleTime: 60000,
  });

  const serviceOptions = services.map((service) => ({
    value: String(service.id),
    label: service.name,
  }));

  const selectedService = services.find(
    (s) => String(s.id) === String(automation.reminderTypeId)
  );

  if (readOnly) {
    if (selectedService?.name) {
      return <span>{t('automations.triggers.lateCanceledVisitFor', { service: selectedService.name })}</span>;
    }
    return <span>{t('automations.triggers.lateCanceledVisit')}</span>;
  }

  // Edit mode
  return (
    <Box sx={{ maxWidth: 300 }}>
      <FormSelect
        name={`automations.${index}.reminderTypeId`}
        label={t('automations.triggerLabels.service')}
        options={serviceOptions}
        prompt={t('automations.triggerLabels.selectService')}
      />
    </Box>
  );
};
